export default "__VITE_ASSET__CjTbev_i__"